export default __webpack_public_path__ + "static/Ambit-SemiBold-2cd473f2c35dfa43b3e7567b3440edae.woff";